<template>
  <div class="container">
    <div class="background">
      <img src="http://www.mymintrabbit.com/img/BGparallax/C1.png" class="cloud1" alt="">
      <div class="pig"></div>
      <img src="http://www.mymintrabbit.com/img/BGparallax/C2.png" class="cloud" alt="">
      <img src="http://www.mymintrabbit.com/img/BGparallax/rainbow.png" class="rainbow" alt="">
      <img src="http://www.mymintrabbit.com/img/BGparallax/glitter.png" class="glitter" alt="">
    </div>
    <div class="header">🐰 🐷 🌕</div>
    <div class="row">
      <div class="col-md-4" v-for="(msg, index) in message" :key="index">
        <div class="card-custom">
          <div class="message">
            {{ msg.content }}
          </div>
          <div class="sent-by">
            <span>{{ `${getDate(msg.timestamp_ms)} - ` }}</span>
            <span class="sender-name">{{ formatName(msg.sender_name) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Messages from '../data/messages.json'
import moment from 'moment'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      message: Messages.messages
    }
  },
  methods: {
    getDate(timestamp_ms) {
      return moment(timestamp_ms).format('L LTS')
    },
    formatName(fullName) {
      const fullname = fullName.split(' ')
      return `${fullname[0]}.${fullname[1].slice(0,1)}`
    }
  }
}
</script>
<style lang="css" scoped>
.glitter, .rainbow {
  width: 100%;
  position: fixed;
  right: 0;
  opacity: 0.8;
}
.rainbow {
  bottom: -120px;
}
.glitter {
  bottom: 0px;
  animation: fade 4s ease-in-out infinite;
}
.cloud {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  opacity: 0.6;
  animation: slide-top 10s ease-in-out infinite;
}
.cloud1 {
  width: 100%;
  position: fixed;
  right: 0;
  top: 0;
  opacity: 0.7;
  animation: slide-top-2 10s ease-in-out infinite;
}
.background {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background-image: linear-gradient( #CF85AB,#C995BE,#D0A9C3,#FCEBF4,#FCEBF4,#FCEBF4,#FCEBF4,#FCEBF4,#FCEBF4);
  background-color: #FCEBF4;
}
.sender-name {
  font-weight: 500;
}
.sent-by {
  color: rgba(148,148,148,0.65);
}
.header {
  font-size: 64px;
  font-weight: 700;
  text-align: center;
  margin: 1em 0;
  z-index: 999;
}
.card-custom {
  border-radius: 4px;
  padding: 1em;
  max-width: 350px;
  margin: 1em;
  box-shadow: 0px 10px 20px 3px rgba(148,148,148,0.1);
  transition: all 0.5s;
  text-align: center;
  background-color:rgba(255,255,255,0.25);
}
.card-custom:hover {
  transition: all 0.25s;
  transform: translateY(-2px);
  box-shadow: 0px 10px 20px 3px rgba(148,148,148,0.25);
}
.message {
  font-size: 42px
}
@keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  50% {
    -webkit-transform: translateY(30px);
            transform: translateY(30px);
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes slide-top-2 {
  0% {
    -webkit-transform: translateY(30px);
            transform: translateY(30);
  }
  50% {
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
  }
  100% {
    -webkit-transform: translateY(30px);
            transform: translateY(30px);
  }
}
@keyframes fade {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.pig {
  width: 298px;
  height: 298px;
  position: absolute;
  top: -50px;
  right: 0;
  background: url('../assets/pig.png');
  animation: playX 0.65s steps(5) infinite,
            playY 0.65s steps(4) infinite,
            slide-top-2 10s ease-in-out infinite;
	}

	@keyframes playX {
	  0% {background-position-x: 0px;}
	  100% {background-position-x: -1490px;}
	}

	@keyframes playY {
	  0% {background-position-y: 0px;}
	  100% {background-position-y: -1192px;}
	}
</style>